/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanySuggestionResource
 */
export interface CompanySuggestionResource {
    /**
     * 
     * @type {string}
     * @memberof CompanySuggestionResource
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySuggestionResource
     */
    text: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CompanySuggestionResource
     */
    others: { [key: string]: string; };
}

/**
 * Check if a given object implements the CompanySuggestionResource interface.
 */
export function instanceOfCompanySuggestionResource(value: object): value is CompanySuggestionResource {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('others' in value) || value['others'] === undefined) return false;
    return true;
}

export function CompanySuggestionResourceFromJSON(json: any): CompanySuggestionResource {
    return CompanySuggestionResourceFromJSONTyped(json, false);
}

export function CompanySuggestionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySuggestionResource {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'text': json['text'],
        'others': json['others'],
    };
}

export function CompanySuggestionResourceToJSON(value?: CompanySuggestionResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'key': value['key'],
        'text': value['text'],
        'others': value['others'],
    };
}

